import React from 'react';
import { useTranslation } from 'react-i18next';
import ProductCodeContainer from '../../common/components/code-container/components/product-code-container';
import { setHomePage } from '../../common/components/emerald-home-page/emerald-home-page';
import { ScannedDataHandler } from '../../devices/scanner-operations';
import PriceCheckScanWindow from '../../price-check/component/price-check-scanning-window';

type Props = IPreSalePriceOverrideProps;

export const showPreSalePriceOverride = (props: Props, onScan: ScannedDataHandler): void => {
  setHomePage(<PreSalePriceOverrideContainer {...props} />, onScan, { enablePluMenu: true });
};

export const PreSalePriceOverrideContainer: React.FC<Props> = (props: Props): JSX.Element => {
  const { t } = useTranslation();
  return (
    <ProductCodeContainer
      headerTitle={t('PreSalePriceOverride')}
      onKeypadSubmit={props.onKeypadSubmit}
    >
      <PriceCheckScanWindow onCancel={props.onCancel} />
    </ProductCodeContainer>
  );
};

export interface IPreSalePriceOverrideProps {
  onCancel: () => void;
  onKeypadSubmit: (input: string) => void;
}
